import React from 'react';
import { RUBY } from './tokens';

/**
 * The RubyTill gem, drawn inline from Branding V2 geometry
 * (01 Logo/SVG/gem/rubytill-gem-transparent-dark.svg). Inline on purpose: the
 * shell screens render before the app and offline, so no CDN asset.
 * `drawing` = cut edge by edge (the brand loader); static otherwise.
 */
const EDGES: [number, number, number, number][] = [
  [432.08, 303.66, 591.92, 303.66], [591.92, 303.66, 641.6, 355.5], [641.6, 355.5, 591.92, 407.34],
  [591.92, 407.34, 432.08, 407.34], [432.08, 407.34, 382.4, 355.5], [382.4, 355.5, 432.08, 303.66],
  [345.68, 266.94, 678.32, 266.94], [678.32, 266.94, 799.28, 418.14], [799.28, 418.14, 648.08, 508.86],
  [648.08, 508.86, 375.92, 508.86], [375.92, 508.86, 224.72, 418.14], [224.72, 418.14, 345.68, 266.94],
  [641.6, 355.5, 799.28, 418.14], [591.92, 407.34, 648.08, 508.86], [432.08, 407.34, 375.92, 508.86],
  [382.4, 355.5, 224.72, 418.14], [799.28, 418.14, 512, 758.34], [648.08, 508.86, 512, 758.34],
  [375.92, 508.86, 512, 758.34], [224.72, 418.14, 512, 758.34],
];
const NODES: [number, number][] = [
  [432.08, 303.66], [591.92, 303.66], [641.6, 355.5], [591.92, 407.34], [432.08, 407.34], [382.4, 355.5],
  [345.68, 266.94], [678.32, 266.94], [799.28, 418.14], [648.08, 508.86], [375.92, 508.86], [224.72, 418.14], [512, 758.34],
];
const CSS = `@keyframes rtShellCut{0%{stroke-dashoffset:420}45%,80%{stroke-dashoffset:0}100%{stroke-dashoffset:-420}}
.rt-shell-gem-draw line{stroke-dasharray:420;animation:rtShellCut 2.4s ease-in-out infinite}
@media (prefers-reduced-motion:reduce){.rt-shell-gem-draw line{animation:none;stroke-dasharray:none}}`;

export function RubyGem({ size = 56, drawing = false, color = RUBY }: { size?: number; drawing?: boolean; color?: string }) {
  return (
    <svg
      width={size} height={(size * 548.4) / 631.56} viewBox="0 0 631.56 548.40" role="img" aria-label="RubyTill"
      className={drawing ? 'rt-shell-gem-draw' : undefined}
    >
      {drawing && <style>{CSS}</style>}
      <g transform="translate(-196.22,-238.44)">
        <g fill="none" stroke={color} strokeWidth={22} strokeLinecap="round" strokeLinejoin="round">
          {EDGES.map(([x1, y1, x2, y2], i) => (
            <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} style={drawing ? { animationDelay: `${(i % 4) * 0.15}s` } : undefined} />
          ))}
        </g>
        <g fill={color}>{NODES.map(([cx, cy], i) => <circle key={i} cx={cx} cy={cy} r={17.5} />)}</g>
      </g>
    </svg>
  );
}
